(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-return-policy"] && !Shopify.designMode) return;
  try {
    (function () {
    var OPEN_CLASS = 'cart-return-policy--open';

    function closeAll(except) {
      document.querySelectorAll('[data-cart-return-policy].' + OPEN_CLASS).forEach(function (wrapper) {
        if (wrapper === except) return;
        wrapper.classList.remove(OPEN_CLASS);
        var trigger = wrapper.querySelector('[data-cart-return-policy-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var trigger = target.closest('[data-cart-return-policy-trigger]');
      if (trigger) {
        var wrapper = trigger.closest('[data-cart-return-policy]');
        if (!wrapper) return;
        var isOpen = wrapper.classList.toggle(OPEN_CLASS);
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        closeAll(wrapper);
        return;
      }

      if (target.closest('[data-cart-return-policy-close]')) {
        closeAll();
        return;
      }

      if (!target.closest('[data-cart-return-policy-popup]')) {
        closeAll();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      var open = document.querySelector('[data-cart-return-policy].' + OPEN_CLASS);
      if (!open) return;
      closeAll();
      var trigger = open.querySelector('[data-cart-return-policy-trigger]');
      if (trigger) trigger.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-purchase-usps"] && !Shopify.designMode) return;
  try {
    /*
    product-purchase-usps
    - Opens the theme's existing PayPo info popup from the PayPo USP.
    - Mirrors the loyalty app's points value (.ll__points-earned) into the banner,
      including later updates (e.g. after a variant change).
  */
  if (!customElements.get('product-purchase-usps')) {
    const POINTS_SOURCE_SELECTOR = '.ll__points-earned';
    const POINTS_SOURCE_WAIT_MS = 10000;
    const PAYPO_POPUP_SELECTOR = '.pdetails--paypo';
    const PAYPO_POPUP_ACTIVE_CLASS = 'is_active';
    const BODY_POPUP_ACTIVE_CLASS = 'pdetails_is_active';

    class ProductPurchaseUsps extends HTMLElement {
      connectedCallback() {
        this.pointsTarget = this.querySelector('[data-purchase-usps-points]');
        this.paypoTrigger = this.querySelector('[data-purchase-usps-paypo]');

        if (this.paypoTrigger) {
          this.handlePaypoClick = this.openPaypoPopup.bind(this);
          this.paypoTrigger.addEventListener('click', this.handlePaypoClick);
        }

        if (this.pointsTarget) this.watchPointsSource();
      }

      disconnectedCallback() {
        if (this.paypoTrigger && this.handlePaypoClick) {
          this.paypoTrigger.removeEventListener('click', this.handlePaypoClick);
        }
        this.stopWaiting();
        if (this.pointsObserver) {
          this.pointsObserver.disconnect();
          this.pointsObserver = null;
        }
      }

      openPaypoPopup() {
        const popup = document.querySelector(PAYPO_POPUP_SELECTOR);
        if (!popup) return;
        const frame = popup.querySelector('iframe[data-src]');
        if (frame && !frame.src) frame.src = frame.dataset.src;
        popup.classList.add(PAYPO_POPUP_ACTIVE_CLASS);
        document.body.classList.add(BODY_POPUP_ACTIVE_CLASS);
      }

      findPointsSource() {
        const scope = this.closest('.product__main__content');
        return (scope && scope.querySelector(POINTS_SOURCE_SELECTOR)) || document.querySelector(POINTS_SOURCE_SELECTOR);
      }

      watchPointsSource() {
        const source = this.findPointsSource();
        if (source) {
          this.observePointsSource(source);
          return;
        }

        // The loyalty app renders asynchronously: wait for it, but not forever.
        this.waitObserver = new MutationObserver(() => {
          const found = this.findPointsSource();
          if (!found) return;
          this.stopWaiting();
          this.observePointsSource(found);
        });
        this.waitObserver.observe(document.body, { childList: true, subtree: true });
        this.waitTimeout = window.setTimeout(() => this.stopWaiting(), POINTS_SOURCE_WAIT_MS);
      }

      stopWaiting() {
        if (this.waitObserver) {
          this.waitObserver.disconnect();
          this.waitObserver = null;
        }
        if (this.waitTimeout) {
          window.clearTimeout(this.waitTimeout);
          this.waitTimeout = null;
        }
      }

      observePointsSource(source) {
        this.syncPoints(source);
        if (this.pointsObserver) this.pointsObserver.disconnect();
        this.pointsObserver = new MutationObserver(() => this.syncPoints(source));
        this.pointsObserver.observe(source, { childList: true, characterData: true, subtree: true });
      }

      syncPoints(source) {
        const value = (source.textContent || '').trim();
        if (!value || this.pointsTarget.textContent === value) return;
        this.pointsTarget.textContent = value;
      }
    }

    customElements.define('product-purchase-usps', ProductPurchaseUsps);
  }
  } catch(e) { console.error(e); }
})();

})();
